import "./style.scss";

const StepIndicator = ({ steps, activeStep, setStep, disabledUpdataBtn }) => {

    const handleStep = (idx) => {
        if (disabledUpdataBtn[idx - 1].isStep) {
            setStep(idx);
        } else {
            if (idx <= activeStep) {
                setStep(idx);
            }
        }
    };

    return (
        <div className="step-indicator">
            {steps.map((step, index) => (
                <div key={index} className={`step__item ${activeStep === step ? "active" : ""} ${activeStep > step ? "passed" : ""}`} onClick={() => handleStep(index + 1)}>
                    <span>{step}</span>
                </div>
            ))}
        </div>
    );
};

export default StepIndicator;
